import { render, staticRenderFns } from "./Pub_Podcasts.vue?vue&type=template&id=1dc4bc01"
import script from "./Pub_Podcasts.vue?vue&type=script&lang=js"
export * from "./Pub_Podcasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports